import { Alert as AntAlert } from 'antd';
import React from 'react';

const Alert = ({
  icon = undefined,
  showIcon = true,
  message = '',
  description = '',
  action = null,
  style = {},
  type = 'info',
}) => {
  return (
    <AntAlert
      icon={icon}
      showIcon={showIcon}
      type={type}
      message={message}
      description={description}
      action={action}
      style={{
        '--ant-margin-xs': 0,
        gap: 16,
        alignItems: 'center',
        ...(!type
          ? {
              border: '1px solid var(--ant-color-border)',
            }
          : {}),
        ...style,
      }}
    />
  );
};

export default Alert;
